import { useContext } from 'react';
import AppContext from '../../../AppContext';
import { DollarFormat } from '../../format';
import CurrentYearExpensesRowData from './CurrentYearExpensesRowData';
import RowHelmet from '../RowHelmet';
import styles from './CurrentYearExpensesRow.module.css';

function rowClassSwitch(rowClass: string = '') {
  switch (rowClass) {
    case 'TOTAL':
      return styles.total_border;
    case 'GRAND_TOTAL':
      return styles.grand_total_border;
    case 'INDENT':
      return styles.indent;
    case 'BOLD':
      return styles.bold;
    default:
      return '';
  }
}

export default function CurrentYearExpensesRow({
  sectionKey,
  rowKey,
  label,
  rowClass,
  direct,
  nonAffAgency,
  affAgency,
  unAllocatedLAE,
  otherOperations,
  investmentExpenses,
  total
}: CurrentYearExpensesRowData) {
  const { showBenchmark } = useContext(AppContext);
  const id = `${sectionKey}-${rowKey}`;

  return (
    <div
      id={id}
      data-testid={id}
      className={`${styles.container} ${showBenchmark ? '' : styles.collapse} ${rowClassSwitch(rowClass)}`}>
      <RowHelmet label={label} />
      <DollarFormat {...direct} />
      <DollarFormat {...nonAffAgency} />
      <DollarFormat {...affAgency} />
      <DollarFormat {...unAllocatedLAE} />
      <DollarFormat {...otherOperations} />
      <DollarFormat {...investmentExpenses} />
      <DollarFormat {...total} />
    </div>
  );
}
